// Example class
let _this = (module.exports = {
  // Set the dom elements
  dom: {
    body: document.querySelector("body"),
  },

  // Set variables
  vars: {
    flag: false,
  },

  hamburger: function () {
    const hamburger = document.querySelector(".hamburger");
    const closeMenu = document.querySelector(".close-menu");
    const socialIcons = document.querySelectorAll(".social-media-icons");
    const openSubmenu = document.querySelector(".menu-item-has-children");
    const body = document.body;
    const html = document.documentElement;

    if (!hamburger) return;

    hamburger.addEventListener("click", () => {
      const isOpen = html.classList.toggle("menu-open");

      if (!isOpen && openSubmenu) {
        openSubmenu.classList.remove("submenu-open");
      }
    });
    closeMenu.addEventListener("click", () => {
      html.classList.remove("menu-open");
      openSubmenu.classList.remove("submenu-open");
    });

    socialIcons.forEach((icon) => {
      icon.addEventListener("click", () => {
        body.classList.remove("menu-open");
        html.classList.remove("menu-open");
        if (openSubmenu) {
          openSubmenu.classList.remove("submenu-open");
        }
      });
    });
  },

  submenu: function () {
    const items = document.querySelectorAll(".menu-item-has-children");

    items.forEach((item) => {
      const link = item.querySelector("a");

      link.addEventListener("click", (e) => {
        if (window.innerWidth <= 991) {
          if (!item.classList.contains("submenu-open")) {
            e.preventDefault();
            item.classList.add("submenu-open");
          }
        }
      });
    });
  },

  /**
   * Init functions
   */
  init: function () {
    this.hamburger();
    this.submenu();
  },
});
